import SendSharp from '@mui/icons-material/SendSharp';

/** Filled warning Send icon for "put on memo" actions (shared across the app). */
export default function DeliverActionIcon({ fontSize = 'small', sx, ...props }) {
  return (
    <SendSharp
      fontSize={fontSize}
      color="warning"
      sx={{
        fill: 'currentColor',
        ...sx,
      }}
      {...props}
    />
  );
}
